import { FieldValues, SubmitHandler, UseFormReturn } from 'react-hook-form'
import styled from 'styled-components'

import { FormFieldsByUniqueID, SimpleFormField } from './formTypes'

export const StyledForm = styled.form<{
  $columns: number
}>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$columns}, 1fr);
  flex-direction: column;
  gap: 0.25rem 1rem;
  margin-bottom: 1rem;
  flex-grow: 1;
  width: 100%;
`

export interface FormComponentProps {
  onSubmit: SubmitHandler<SimpleFormField>
  formFieldsByUniqueID: FormFieldsByUniqueID[]
  numberOfColumns?: number
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  propForm?: UseFormReturn<SimpleFormField, any, FieldValues>
}
